// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikInput } from "src/components/Forms/TextInput";
import { Typography } from "src/components/Core/Typography";

interface Props {}

const Caption: React.FC<Props> = () => {
  return (
    <Field label="Caption:" mb={26}>
      <FormikInput
        name="caption"
        size="middle"
        placeholder="caption"
        borderRadius={2}
        borderColor="grey5"
      />
      <Typography size={14} color="grey7">
        Please enter the caption you would post with your content.
      </Typography>
    </Field>
  );
};

export default Caption;
